import {
  reportIntentPages,
  type ReportIntentPageSlug,
} from "@ishvaram/domain-data/report-intent-pages";
import type { SEOIntent } from "@/lib/seo-intents";

export type ReportIntentSlug = ReportIntentPageSlug;

export interface ReportIntentConfig {
  readonly slug: ReportIntentSlug;
  readonly reportSlug: string;
  readonly intent: SEOIntent;
  readonly eyebrow: string;
  readonly title: string;
  readonly description: string;
  readonly lead: string;
  readonly checkpoints: readonly string[];
  readonly fit: string;
  readonly inputSurface: "kundali" | "matching";
  readonly offerHeadline: string;
  readonly offerSubhead: string;
  readonly collectInputsLabel: string;
  readonly customerProblem: string;
  readonly faq: readonly { readonly q: string; readonly a: string }[];
}

export const REPORT_INTENT_PAGES = reportIntentPages as Record<
  ReportIntentSlug,
  ReportIntentConfig
>;

export const REPORT_INTENT_SLUGS = Object.keys(REPORT_INTENT_PAGES) as ReportIntentSlug[];

const HINDI_REPORT_INTENT_SLUGS = new Set<ReportIntentSlug>([
  "career-report",
  "marriage-report",
  "dosha-report",
  "dosha-remedy-plan",
]);
const REPORT_INTENT_SLUG_SET = new Set<string>(REPORT_INTENT_SLUGS);

/** True only for an existing report conversion landing, including Hindi twins. */
export function isReportIntentLandingPath(pathname: string): boolean {
  const path = pathname.split(/[?#]/, 1)[0].replace(/\/+$/, "") || "/";
  const segments = path.split("/").filter(Boolean);
  if (segments.length === 1) return isReportIntentSlug(segments[0]);
  return (
    segments.length === 2 &&
    segments[0] === "hi" &&
    isReportIntentSlug(segments[1]) &&
    HINDI_REPORT_INTENT_SLUGS.has(segments[1])
  );
}

function isReportIntentSlug(value: string): value is ReportIntentSlug {
  return REPORT_INTENT_SLUG_SET.has(value);
}
